export default "__VITE_ASSET__07422f64__"